export const anonymizeVoucherCode = (voucherCode: string) =>
    voucherCode.replace(/([CGT]-.)\w{5}-(\w{6}-)?(\w{6}-)?(\d{3})/, "$1*****$4");
